import * as queries from "./query";
import * as mutations from "./mutation";
import * as validations from "./validation";

import RootService from "@services";

export default new RootService({ queries, mutations, validations });
